<div
  class="efile-errors"
  [class.efile-errors--first-run]="!loadingErrors && !loadError && errors && errors.length === 0 && firstRun"
>
  <!-- Left: form list card with select-all + refresh + per-form chips -->
  <div class="efile-errors__forms-card" [class.shadowed]="showErrors">
    <div class="efile-errors__forms-card__header">
      <label class="switch">
        <input
          type="checkbox"
          [checked]="selectAllToggle"
          (change)="onSelectAllToggle()"
          [disabled]="loadingErrors || !errors || errors.length === 0"
        />
        <span class="slider round"></span>
      </label>
      <label class="form-check-label">Select All</label>
      <i
        class="fa fa-refresh refresh-icon"
        role="button"
        tabindex="0"
        (click)="refresh()"
        (keyup.enter)="refresh()"
        title="Refresh"
        aria-label="Refresh form list"
      ></i>
    </div>

    <div class="efile-errors__forms-card__body">
      @if (loadingErrors) {
<div class="error-loader">
        <i class="fa fa-spinner fa-spin fa-4x" aria-hidden="true"></i>
      </div>
}

      @if (!loadingErrors && loadError) {
<div class="error-message">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        {{ loadError }}
        <button type="button" class="retry-btn" (click)="refresh()">Retry</button>
      </div>
}

      <!-- First-run / all-resolved hero card -->
      @if (!loadingErrors && !loadError && errors && errors.length === 0) {
<div
        class="centered"
       
      >
        <div
          class="first-run"
          role="button"
          tabindex="0"
          (click)="firstRun && onValidateClick()"
          (keyup.enter)="firstRun && onValidateClick()"
        >
          @if (validating) {
<div><span></span></div>
}
          <i
            class="fa"
            [ngClass]="{ 'fa-gear': firstRun, 'fa-check': !firstRun }"
            aria-hidden="true"
          ></i>
        </div>
        @if (firstRun) {
<h2>Please click above to run the validation.</h2>
}
        @if (!firstRun) {
<h2>
          All errors are resolved. Please click here
          <span
            class="mini-gear"
            role="button"
            tabindex="0"
            (click)="onValidateClick()"
            (keyup.enter)="onValidateClick()"
            title="Re-run validation"
          >
            <i class="fa fa-gear" aria-hidden="true"></i>
          </span>
          to rerun the validation.
        </h2>
}
      </div>
}

      @if (!loadingErrors && !loadError && errors && errors.length > 0) {
<div
        class="icons-list"
       
        [class.collapsed]="showErrors"
      >
        @for (row of errors; track trackByIndex(i); let i = $index) {
<div
          class="icon"
         
          [class.active]="formCheckbox[i]"
        >
          <div
            class="icon-svg"
            role="button"
            tabindex="0"
            (click)="selectOnly(i)"
            (keyup.enter)="selectOnly(i)"
            [title]="row.FORM"
          >
            <!-- Legacy IRS validation form chip: PDF artwork from errors.html -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="65.668"
              height="52"
              viewBox="0 0 65.668 52"
              class="validation-form-pdf-icon"
              aria-hidden="true"
              focusable="false"
            >
              <g transform="translate(-2 -2)">
                <g>
                  <g transform="translate(-19 -43)">
                    <g transform="translate(-17 -4)">
                      <rect width="25" height="4" transform="translate(56 49)" fill="#dddcdf" />
                      <rect width="40" height="4" transform="translate(56 97)" fill="#dddcdf" />
                      <rect width="27" height="4" transform="translate(96 73) rotate(90)" fill="#dddcdf" />
                      <rect width="50" height="4" transform="translate(60 50) rotate(90)" fill="#dddcdf" />
                      <path
                        d="M-167.209-44h-11.039l-6.877,10.272,6.877,9.772h11.039l6.877-9.772Z"
                        transform="translate(264 94)"
                        fill="#aaa"
                      />
                      <rect width="44" height="19" transform="translate(38 70)" fill="#e45f0f" />
                      <path
                        d="M6.63-7.953v1.367H2.53v2.562H5.761V-2.7H2.535V-.088h4.1V1.286H.8V-7.953Zm1.4,9.239V-5.269h.926a.5.5,0,0,1,.339.089.514.514,0,0,1,.128.307l.1.792a3.115,3.115,0,0,1,.824-.958A1.734,1.734,0,0,1,11.4-5.391a1.371,1.371,0,0,1,.805.224L12-3.985a.244.244,0,0,1-.083.163.281.281,0,0,1-.173.048,1.076,1.076,0,0,1-.262-.045,1.753,1.753,0,0,0-.441-.045,1.338,1.338,0,0,0-.843.272,2.091,2.091,0,0,0-.594.8V1.286Zm5.22,0V-5.269h.926a.5.5,0,0,1,.339.089.514.514,0,0,1,.128.307l.1.792a3.115,3.115,0,0,1,.824-.958,1.734,1.734,0,0,1,1.061-.351,1.371,1.371,0,0,1,.805.224l-.2,1.182a.244.244,0,0,1-.083.163.281.281,0,0,1-.173.048,1.076,1.076,0,0,1-.262-.045,1.753,1.753,0,0,0-.441-.045,1.338,1.338,0,0,0-.843.272,2.091,2.091,0,0,0-.594.8V1.286Zm8.019-6.658a3.593,3.593,0,0,1,1.332.236,2.873,2.873,0,0,1,1.019.671A2.97,2.97,0,0,1,24.272-3.4,4.035,4.035,0,0,1,24.5-2a4.054,4.054,0,0,1-.228,1.4A3.035,3.035,0,0,1,23.62.468a2.831,2.831,0,0,1-1.019.677,3.593,3.593,0,0,1-1.332.236,3.618,3.618,0,0,1-1.335-.236A2.857,2.857,0,0,1,18.908.468,3.049,3.049,0,0,1,18.249-.6,4,4,0,0,1,18.016-2a3.985,3.985,0,0,1,.233-1.4,2.983,2.983,0,0,1,.658-1.061,2.9,2.9,0,0,1,1.026-.671,3.618,3.618,0,0,1,1.335-.24Zm0,5.54A1.388,1.388,0,0,0,22.48-.381a2.755,2.755,0,0,0,.393-1.61,2.787,2.787,0,0,0-.393-1.617,1.382,1.382,0,0,0-1.211-.556,1.4,1.4,0,0,0-1.227.559,2.772,2.772,0,0,0-.4,1.613,2.741,2.741,0,0,0,.4,1.607,1.407,1.407,0,0,0,1.226.553Zm4.466,1.118V-5.269h.926A.5.5,0,0,1,27-5.18a.514.514,0,0,1,.128.307l.1.792a3.115,3.115,0,0,1,.824-.958,1.734,1.734,0,0,1,1.061-.351,1.371,1.371,0,0,1,.8.224l-.2,1.182a.244.244,0,0,1-.083.163.281.281,0,0,1-.173.048,1.076,1.076,0,0,1-.262-.045,1.753,1.753,0,0,0-.441-.045,1.338,1.338,0,0,0-.843.272,2.091,2.091,0,0,0-.594.8V1.286Zm9.111-5.278a.421.421,0,0,1-.134.144.348.348,0,0,1-.179.042.564.564,0,0,1-.246-.064l-.3-.144a2.78,2.78,0,0,0-.393-.144,1.882,1.882,0,0,0-.521-.064,1.213,1.213,0,0,0-.735.2.614.614,0,0,0-.268.518.494.494,0,0,0,.137.355,1.235,1.235,0,0,0,.364.252,3.564,3.564,0,0,0,.514.2q.288.086.588.188t.588.233a2.05,2.05,0,0,1,.514.332,1.543,1.543,0,0,1,.364.482,1.53,1.53,0,0,1,.137.677A2.176,2.176,0,0,1,35.1.082a1.917,1.917,0,0,1-.5.69,2.365,2.365,0,0,1-.821.454,3.542,3.542,0,0,1-1.121.163A3.57,3.57,0,0,1,32,1.328a3.9,3.9,0,0,1-.62-.169A3.43,3.43,0,0,1,30.824.9,2.667,2.667,0,0,1,30.38.583l.364-.6a.515.515,0,0,1,.166-.166.466.466,0,0,1,.243-.058.51.51,0,0,1,.278.083q.131.083.3.179A2.713,2.713,0,0,0,32.14.2a1.785,1.785,0,0,0,.591.083,1.533,1.533,0,0,0,.482-.067A1.021,1.021,0,0,0,33.546.04a.66.66,0,0,0,.192-.252.757.757,0,0,0,.061-.3.53.53,0,0,0-.137-.377,1.2,1.2,0,0,0-.364-.256,3.518,3.518,0,0,0-.518-.195q-.291-.086-.594-.188a5.5,5.5,0,0,1-.594-.24,2.025,2.025,0,0,1-.518-.348,1.576,1.576,0,0,1-.364-.518,1.806,1.806,0,0,1-.137-.741,1.888,1.888,0,0,1,.16-.767,1.8,1.8,0,0,1,.47-.636,2.332,2.332,0,0,1,.773-.434,3.221,3.221,0,0,1,1.07-.163,3.276,3.276,0,0,1,1.233.224,2.785,2.785,0,0,1,.926.588Z"
                        transform="translate(43.601 82.35)"
                        fill="#fff"
                      />
                    </g>
                    <text
                      transform="translate(71 60)"
                      fill="#fff"
                      font-size="13"
                      font-family="Arial, Helvetica, sans-serif"
                    >
                      <tspan [attr.x]="row.ERROR_COUNT > 9 ? -4 : 0" y="0">{{ row.ERROR_COUNT }}</tspan>
                    </text>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="icon-text">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="formCheckbox[i]"
              (change)="onFormCheckboxChange(i, row)"
            />
            <label class="form-check-label">{{ row.FORM }}</label>
          </div>
        </div>
}
      </div>
}
    </div>
  </div>

  <!-- Right: gizmoGrid for selected form_id -->
  @if (showErrors && gridConfig) {
<div class="efile-errors__grid-host">
    <div
      efileGrid
      #gridRef="efileGrid"
      class="gizmo-grid"
      [gridConfig]="gridConfig"
      (gridCallback)="onErrorsGridCallback($event)"
    ></div>
  </div>
}
</div>

@if (showConfirmModal) {
<gtw-confirmation-modal
 
  [config]="confirmModalConfig"
  [visible]="showConfirmModal"
  (confirmed)="onConfirmModal()"
  (cancelled)="onCancelValidate()"
  (closed)="onCancelValidate()"
></gtw-confirmation-modal>
}
